import {
  useApplicationSettingsContext,
  useBreadcrumbContext,
  useFacetContext,
  useRouterContext,
} from '../../../context/PlpContext';

export const useAdtechBannerData = () => {
  const { adtechBannerService } = useApplicationSettingsContext();
  const { breadcrumbs } = useBreadcrumbContext();
  const { facetsInformation = {} } = useFacetContext();
  const {
    appliedProductTypes = [],
    isFilteredByBrand,
    isFiltered,
  } = facetsInformation;
  const router = useRouterContext();
  const { query } = router;
  const { 'search-term': searchTerm, type } = query;

  return {
    applicationSettings: { adtechBannerService },
    breadcrumbContext: { breadcrumbs },
    facetContext: {
      appliedProductTypes,
      isFilteredByBrand,
      isFiltered,
    },
    router: {
      searchTerm,
      type,
    },
  };
};
